import React, {useContext} from 'react';
import {StoreContext} from '../base/root-store';
import {observer} from 'mobx-react-lite';
import {
    Header,
    IButtonProps,
    IChatAnswerProps,
    IChatMessageProps,
    ILogoProps,
    Main,
    TChatItem,
    TemplateChat,
} from '../../../patterns';
import {formatToDayMonthAndYear} from '../base/dateUtils';
import {MultipleChoiceAction, StationMessage, StationStore} from './station-store';
import {ErrorBoundary} from '../base/ErrorBoundary';
import {GenericError} from '../base/GenericError';
import logoMoticheck from '../assets/logo_moticheck_new.png';
import logoGardenHotels from '../assets/logo-garden-hotels.png';

export const StationPage = observer((): JSX.Element => {
    const store = useContext(StoreContext).stationStore;

    if (store.state === 'error') {
        return <ErrorBoundary>
            <Main showBackground={true}>
                <GenericError/>
            </Main>
        </ErrorBoundary>;
    }
    if (store.state === 'loading') {
        return <ErrorBoundary>
            <Main showBackground={true}>
                <TemplateChat chat={{
                    isLoading: true,
                }}/>
            </Main>
        </ErrorBoundary>;
    }

    const items: TChatItem[] = store.variables.preparedMessages
        .map((message) => message.party === 'bot' ? messageProps(message) : answerProps(message));

    return <ErrorBoundary>
        <Main showBackground={true}>
            <Header logo={logoProps(store)}/>
            <TemplateChat chat={{
                items,
                reply: store.payload!.translatableQuestionId !== undefined ? replyProps(store) : undefined,
            }}/>
        </Main>
    </ErrorBoundary>;

});

const messageProps = (message: StationMessage): IChatMessageProps => ({
    element: 'message',
    message: message.text,
    time: {
        iso: message.date,
        value: formatToDayMonthAndYear(message.date),
    },
});

const answerProps = (message: StationMessage): IChatAnswerProps => ({
    element: 'answer',
    text: message.text,
    color: message.color === 'white' ? undefined : message.color,
    time: {
        iso: message.date,
        value: formatToDayMonthAndYear(message.date),
    },
});

const replyProps = (store: StationStore): IButtonProps[] | undefined => {
    const action = store.variables.action;

    if (action === undefined) {
        return undefined;
    }

    if (action instanceof MultipleChoiceAction) {
        return action.choices.map((choice) => ({
            text: choice.text,
            color: choice.color,
            onClick: (): void => store.onSubmitChoice(choice.value),
        }));
    }
};

const logoProps = (store: StationStore): ILogoProps => {

    let companyLogo;

    if (store.payload!.companyId === 'bf0aaaf5-11f5-415a-8009-0efbfaf18a35') {
        companyLogo = logoGardenHotels;
    } else {
        companyLogo = logoMoticheck;
    }

    return (
        {
            url: '#',
            image: companyLogo,
            title: 'Moticheck',
        }
    );
};
